import styled from 'styled-components'

import { Grid, Skeleton } from '@sketch/components'
import EmptyStateUnstyled from '../../components/EmptyState'

export const EmptyState = styled(EmptyStateUnstyled)`
  margin: 0 auto;
`

export const StyledSkeleton = styled(Skeleton)`
  margin-top: 12px;
`

export const StyledGrid = styled(Grid)`
  grid-template-rows: max-content;
`
